import React from 'react';
import PropTypes from 'prop-types';
import RadarChartComponent from './RadarChartComponent';
import SoftSkillsList from './SoftSkillsList';
import CustomTooltip from '../../Utils/CustomTooltip';

const SoftSkillsSection = ({ softSkills, showSources = true }) => {
  // BACKWARDS COMPATIBILITY -> Helper function to get items array, checking both 'items' and 'value' properties
  const getItemsArray = (data) => {
    if (Array.isArray(data?.items) && data.items.length > 0) {
      return data.items;
    } else if (Array.isArray(data?.value) && data.value.length > 0) {
      return data.value;
    }
    return [];
  };
  
  // Get the skills array
  const skillsArray = getItemsArray(softSkills);
  return (
    <div className="border border-gray-200 rounded-lg p-6 bg-white">
      <div className="flex justify-between items-start mb-4">
        <h4 className="text-xl font-semibold text-gray-800">Soft Skills</h4>
        {showSources && softSkills?.source && (
          <CustomTooltip content={softSkills.source} position="left">
            <span className="text-xs text-blue-600 cursor-help hover:text-blue-800 flex items-center">
              <svg className="w-3 h-3 mr-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z" />
              </svg>
              Source
            </span>
          </CustomTooltip>
        )}
      </div>
      
      {skillsArray.length > 0 ? (
        <div>
          {/* Radar Chart for Soft Skills */}
          <RadarChartComponent 
            data={skillsArray.map(skill => ({
              subject: skill.skill.replace(/([A-Z])/g, ' $1').replace(/^./, str => str.toUpperCase()),
              value: parseFloat(skill.score || skill.grade) || 0 // BACKWARDS COMPATIBILITY -> can be either 'score' or 'grade'
            }))}
            title="Soft Skills Radar"
            height="h-[500px]"
            marginTop="mt-0"
            marginBottom="mb-12"
          />
          
          {/* Soft Skills List Component */}
          <SoftSkillsList skills={skillsArray} showSources={showSources} />
        </div>
      ) : (
        <p className="text-gray-600">No soft skills data available.</p>
      )}
    </div>
  );
};

SoftSkillsSection.propTypes = {
  softSkills: PropTypes.object,
  showSources: PropTypes.bool
};

export default SoftSkillsSection;
